import { render } from "./LeaveCarryAdmin.vue?vue&type=template&id=5941c844&scoped=true"
import script from "./LeaveCarryAdmin.vue?vue&type=script&lang=js"
export * from "./LeaveCarryAdmin.vue?vue&type=script&lang=js"

import "./LeaveCarryAdmin.vue?vue&type=style&index=0&id=5941c844&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5941c844"]])

export default __exports__